import { ListingStatusEnum } from '@doltech/utils/lib/constants';
import { keys, values } from 'lodash';
import { Instance, types } from 'mobx-state-tree';

import { FilterStoreInstance } from '@doltech/ui/lib/filter/Filter/FilterStore';
import { FilterModel } from '@doltech/ui/lib/filter/Filter/model/FilterModel';

export const ListingFactFilterModel = FilterModel.named('ListingFactFilterModel')
  .props({
    listedStatuses: types.array(types.enumeration<any>(values(ListingStatusEnum))),
    fromDate: types.maybeNull(types.string),
    toDate: types.maybeNull(types.string),
  })
  .actions((self) => {
    const { updateViaQuery } = self;

    return {
      updateFilter(data) {
        keys(data).forEach((k) => {
          self[k] = data[k];
        });
        self.page = 1;
      },
      updateViaQuery(data) {
        if (data.listedStatuses) {
          self.listedStatuses = data.listedStatuses;
        }
        if (data.fromDate) {
          self.fromDate = data.fromDate;
        }
        if (data.toDate) {
          self.toDate = data.toDate;
        }
        updateViaQuery(data);
      },
      clearFilter() {
        self.fromDate = null;
        self.toDate = null;
        self.listedStatuses.clear();
      },
    };
  });

export interface ListingFactFilterModelInstance extends Instance<typeof ListingFactFilterModel> {}

export type ListingFactFilterStoreInstance = ListingFactFilterModelInstance & FilterStoreInstance;
